import React from 'react';
import styled from 'styled-components';

export const SkillProjectButton = ({ content, colorset }) => {
    const StyledSkillButton = styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
        border: 2px solid ${colorset};
        background-color: transparent;
        width: fit-content;
        height: fit-content;
        padding: 1%;
        border-radius: 15px;
        margin-right: 5px;
    `;

    const Text = styled.p`
        margin: 0;
        font-size: 9px;
        font-weight: 600;
        color: ${colorset};
    `;

    return (
        <StyledSkillButton>
            <Text>{content}</Text>
        </StyledSkillButton>
    );
};

const SkillButton = ({ content, colorset }) => {
    const StyledSkillButton = styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
        border: 2px solid ${colorset};
        background-color: transparent;
        width: fit-content;
        height: fit-content;
        padding: 5px;
        border-radius: 15px;
        margin-right: 5px;
    `;

    const Text = styled.p`
        margin: 0;
        font-size: 12px;
        font-weight: 600;
        color: ${colorset};
    `;

    return (
        <StyledSkillButton>
            <Text>{content}</Text>
        </StyledSkillButton>
    );
};

export default SkillButton;
